import { render, staticRenderFns } from "./newChatMessage.vue?vue&type=template&id=f651260e"
import script from "./newChatMessage.vue?vue&type=script&lang=js"
export * from "./newChatMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports